import { dispatch } from "../utilities/dom-events";
function elementChildren(element, nodeType) {
    if (nodeType === void 0) { nodeType = Node.ELEMENT_NODE; }
    var childNodes = element.childNodes;
    var children = [];
    if (childNodes && childNodes.length > 0) {
        var i = childNodes.length;
        while (i--) {
            if (childNodes[i].nodeType === nodeType) {
                children.unshift(childNodes[i]);
            }
        }
    }
    return children;
}
var hypenRegEx = /-([a-z])/g;
var SlotsEvent;
(function (SlotsEvent) {
    SlotsEvent["SlotsChange"] = "slots-change-event";
})(SlotsEvent || (SlotsEvent = {}));
function slots() {
    return {
        get: function (host) {
            var slots = {
                default: []
            };
            var children = elementChildren(host);
            children.forEach(function (child) {
                var attribute = child.getAttribute ? child.getAttribute("slot") : null;
                if (typeof attribute === "string" && attribute.length > 0) {
                    var slot = attribute.replace(hypenRegEx, function (match) { return match[1].toUpperCase(); });
                    slots[slot] = child;
                }
                else {
                    slots.default.push(child);
                }
            });
            return slots;
        },
        observe: function (host) {
            dispatch(host, SlotsEvent.SlotsChange);
        }
    };
}
export { slots, SlotsEvent };
//# sourceMappingURL=slots.js.map